import { makeObservable, observable } from 'mobx'
import * as R from 'ramda'

import { unescapeHtmlTags } from '../../../helpers'

class EmailUsageStore {
    data = []

    @observable filteredData = []

    @observable clients = []

    @observable loading = true

    columns = [
        {
            name: 'Client',
            key: 'clientName',
            dataTransform: (clientName) => (
                unescapeHtmlTags(clientName)
            ),
        },
        {
            name: 'Licence instance',
            key: 'productName',
            dataTransform: (productName, { productEdition }) => (
                unescapeHtmlTags(`${productName}${!R.isEmpty(productEdition) ? ` - ${productEdition}` : ''}`)
            ),
        },
        {
            name: 'Product type',
            key: 'productTypeName',
        },
        {
            name: 'Year',
            key: 'year',
        },
        {
            name: 'GE email allocated',
            key: 'allocatedGeEmails',
        },
        {
            name: 'GE emails sent',
            key: 'sentGeEmails',
        },
        {
            name: 'Pe emails sent',
            key: 'sentPeEmails',
        },
    ]

    constructor(store) {
        makeObservable(this)
        this.store = store
    }

    init = async () => {
        await this.getClients()
        this.loading = false
    }

    getClients = async () => {
        try {
            const { clients } = await this.store.http.get('/client')
            this.clients = clients
                .filter(({ active }) => active)
                .map(({ clientId, name }) => ({
                    value: clientId,
                    label: name,
                }))
        } catch (e) {
            console.error(e)
            this.store.handleError({ body: 'Error loading clients', level: 'error' })
        }
    }

    changeClient = ({ value }) => {
        this.clientId = value
        this.filterData()
    }

    filterData = () => {
        this.filteredData = this.data.filter(({ clientId }) => (
            !this.clientId || clientId === this.clientId
        ))
    }

    getData = async (year) => {
        try {
            this.loading = true
            let url = '/intranet/emailUsage/all'
            if (!R.isEmpty(year) && !R.isNil(year)) {
                url += `?year=${year}`
            }
            this.data = await this.store.http.get(url)
        } catch (e) {
            console.error(e)
            this.store.handleError({ body: 'Error loading data', level: 'error' })
        }

        this.filterData()
        this.loading = false
    }
}

export default EmailUsageStore
